import { Route, Routes } from "react-router-dom";

import axios from "axios";
import Cookies from "js-cookie";

import Home from "./Home";
import AuthProvider from "./auth/AuthProvider";
import PrivateRoute from "./auth/PrivateRoute";
import Header from "./components/Header/Header";
import Dashboard from "./pages/dashboard/Dashboard";
import ReportTraffic from "./pages/reports/traffic";
import TrafficPage from "./pages/traffic/traffic";
import JuricalPage from "./pages/jurical/Jurical";
import ProfilePage from "./pages/profile/Profile";
import TariffsPage from "./pages/tariffs/tariffs";
import PaymentPageHistory from "./pages/payment/history";
import DocumentsPage from "./pages/documents/documents";
import LoginPhonePage from "./pages/login/login";
import RecoveryPage from "./pages/recovery/recoveryPage";
import NoAccess from "./pages/noAccess/NoAccess";
import AccountsHistory from "./pages/payment/accounts_history";

axios.defaults.baseURL = "https://selfcare.lansat.ru/api_v1/";
//axios.defaults.baseURL = "http://localhost:9890/";
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      Cookies.remove("customer_sid");
      Cookies.remove("");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login-phone" element={<LoginPhonePage />} />
        <Route path="/recovery" element={<RecoveryPage />} />
        <Route path="/inet/activate" element={<NoAccess />} />

        <>
          <Route path="/dashboard" element={

            <PrivateRoute>
              <Header />
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/traffic/stat" element={
            <PrivateRoute>
              <Header />
              <TrafficPage />
            </PrivateRoute>} />
          <Route path="/profile" element={
            <PrivateRoute>
              <Header />
              <ProfilePage />
            </PrivateRoute>
          } />
          <Route path="/tariffs/list" element={
            <PrivateRoute>
              <Header />
              <TariffsPage />
            </PrivateRoute>
          } />
          <Route path="/jurical/tariffs" element={
            <PrivateRoute>
              <Header />
              <JuricalPage />
            </PrivateRoute>
          } />

          <Route path="/doc" element={
            <PrivateRoute>
              <Header />
              <DocumentsPage />
            </PrivateRoute>
          } />

          <Route path="/accounts" element={
            <PrivateRoute>
              <Header />
              <AccountsHistory />
            </PrivateRoute>
          } />

          <Route path="/report/traffic" element={
            <PrivateRoute>
              <Header />
              <ReportTraffic />
            </PrivateRoute>
          } />

          <Route path="/payment/history" element={
            <PrivateRoute>
              <Header />
              <PaymentPageHistory />
            </PrivateRoute>
          } />

          <Route path="/accounts" element={
            <PrivateRoute>
              <Header />
              <AccountsHistory />
            </PrivateRoute>
          } />
        </>
        {/* <Route path="*" element={<NoFound />} /> */}
      </Routes>
    </AuthProvider>
  );
}

export default App;
